import { GetAllProfessional } from '~/domain/usecases/professionalList/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
  NotFound,
} from '~/domain/errors';

export class RemoteGetAllProfessional implements GetAllProfessional {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetAllProfessional.Model>;

  constructor(url: string, httpClient: HttpClient<GetAllProfessional.Model>) {
    this.url = url;
    this.httpClient = httpClient;
  }

  getAll = async (
    params: GetAllProfessional.Params,
  ): Promise<GetAllProfessional.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
